var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM6.75008 7.05004V8.35004C6.4053 8.35004 6.07464 8.487 5.83085 8.7308C5.58705 8.97459 5.45009 9.30525 5.45009 9.65003V12.9C5.45009 13.2448 5.58705 13.5755 5.83085 13.8193C6.07464 14.0631 6.4053 14.2 6.75008 14.2H13.2501C13.5948 14.2 13.9255 14.0631 14.1693 13.8193C14.4131 13.5755 14.5501 13.2448 14.5501 12.9V9.65003C14.5501 9.30525 14.4131 8.97459 14.1693 8.7308C13.9255 8.487 13.5948 8.35004 13.2501 8.35004V7.05004C13.2501 6.18809 12.9077 5.36144 12.2982 4.75195C11.6887 4.14246 10.862 3.80005 10.0001 3.80005C9.13812 3.80005 8.31147 4.14246 7.70198 4.75195C7.09249 5.36144 6.75008 6.18809 6.75008 7.05004ZM11.9501 8.35004V7.05004C11.9501 6.53287 11.7446 6.03688 11.3789 5.67119C11.0132 5.30549 10.5172 5.10005 10.0001 5.10005C9.4829 5.10005 8.98691 5.30549 8.62122 5.67119C8.25552 6.03688 8.05008 6.53287 8.05008 7.05004V8.35004H11.9501Z",
    fill: "#3461B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain);
export default __webpack_public_path__ + "static/media/retain.2d29d9c5bafae9c56a145d0193da3766.svg";
export { ForwardRef as ReactComponent };